import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { getOrCreateSyncDeviceId } from '../../sync/core/syncDeviceId';

const WEB_DEVICE_ID_KEY = '@vuelto/client_device_id';

let cachedWebDeviceId: string | null = null;

function getWebStorage(): Storage | null {
  if (Platform.OS !== 'web' || typeof globalThis.localStorage === 'undefined') {
    return null;
  }
  return globalThis.localStorage;
}

async function getOrCreateWebDeviceId(): Promise<string> {
  if (cachedWebDeviceId) return cachedWebDeviceId;
  const storage = getWebStorage();
  if (storage) {
    const existing = storage.getItem(WEB_DEVICE_ID_KEY);
    if (existing && existing.trim().length >= 8) {
      cachedWebDeviceId = existing.trim();
      return cachedWebDeviceId;
    }
    const next = crypto.randomUUID();
    cachedWebDeviceId = next;
    try {
      storage.setItem(WEB_DEVICE_ID_KEY, next);
    } catch {
      // in-memory only for this session
    }
    return next;
  }
  const fallback = crypto.randomUUID();
  cachedWebDeviceId = fallback;
  return fallback;
}

/** Stable device id per installation (web localStorage or native sync device id). */
export async function getClientDeviceId(): Promise<string> {
  if (Platform.OS === 'web') {
    return getOrCreateWebDeviceId();
  }
  return getOrCreateSyncDeviceId();
}

export function resetClientDeviceIdCacheForTests(): void {
  cachedWebDeviceId = null;
}
